import Waypoint from "./Waypoint";
import Main from "~/js/Main";

export default class PostLoader {
	static get LoadStart() {
		return "PostLoader.Start";
	}

	static get LoadSuccess() {
		return "PostLoader.Success";
	}

	static get LoadError() {
		return "PostLoader.Error";
	}

	/**
	 *
	 * @param {HTMLElement} containerElement
	 * @param {string} postType
	 */
	constructor(containerElement, postType) {
		this.container = containerElement;
		this.id = this.container.id;
		this.postType = postType;
		/**
		 *
		 * @type {HTMLButtonElement}
		 */
		this.triggerButton = window.document.getElementById(`${this.id}__LoadMoreButton`);
		this.isAutoLoadOnInView = this.getIsAutoLoad();
		this.isLoading = false;

		/**
		 *
		 * @type {Waypoint}
		 */
		this.waypoint = null;
		this.init();
	}


	init() {
		this.container.dataset.loader = JSON.stringify(this);
		this.triggerButton.addEventListener("click", this.onTriggerClick.bind(this));

		if (this.isAutoLoadOnInView) {
			this.triggerButton.dataset.triggerAlways = "";
			this.waypoint = new Waypoint(this.triggerButton);

			this.triggerButton.addEventListener(Waypoint.InViewClass, this.loadArticles.bind(this));
		}
		else {
			this.loadArticles();
		}
	}

	/**
	 *
	 * @return {boolean}
	 */
	getIsAutoLoad() {
		return this.container.getAttribute("data-autoload") === "1";
	}

	/**
	 *
	 * @return {number}
	 */
	getLoadMax() {
		return parseInt(this.container.getAttribute("data-load-max"));
	}

	/**
	 *
	 * @param {number} value
	 */
	setLoadMax(value) {
		this.container.setAttribute("data-load-max", value.toString());
	}

	/**
	 *
	 */
	loadArticles() {
		let loadMax = window.parseInt(this.container.getAttribute("data-load-max"));
		let total = window.parseInt(this.container.getAttribute("data-total"));
		let loadedPostIDs = this.container.getAttribute("data-loaded-id");
		let loopTpl = this.container.getAttribute("data-loop-tpl");
		let nonce = this.container.getAttribute("data-nonce");
		let vars = this.container.getAttribute("data-query-vars");
		const numLoaded = loadedPostIDs.split(",").length;

		if (nonce === undefined || (numLoaded >= total && total !== 0)) {
			this.triggerButton.remove();
			return;
		}

		this.container.dispatchEvent(new Event(PostLoader.LoadStart));
		this.isLoading = true;

		const data = new FormData();
		data.append("action", "Posts/Load");
		data.append("_wpnonce", nonce);
		data.append("loadMax", loadMax);
		data.append("loadedPostIDs", loadedPostIDs);
		data.append("loopTpl", loopTpl);
		data.append("queryVars", vars);

		if (this.triggerButton !== null) {
			this.triggerButton.classList.add("loading");
		}

		window.fetch(Main.Instance.url.ajax, {
			body: data,
			method: "POST",
			credentials: "same-origin",
			headers: {
				"Accept": "application/json"
			}
		}).then(async (resp) => {
			if (this.triggerButton !== null) {
				this.triggerButton.classList.remove("loading");
				this.triggerButton.classList.remove(Waypoint.InViewClass);
				this.triggerButton.classList.remove(Waypoint.LeftViewClass);
			}

			const result = await resp.json();

			this.onLoadSuccess(result.data);
		}).catch(reason => {
			this.onLoadError(reason);
		})
			.finally(() => {
				this.isLoading = false;
				this.maybeRemoveTriggerButton();
			});
	}

	maybeRemoveTriggerButton() {
		const foundRows = window.parseInt(this.container.getAttribute("data-total"));
		const loadedIds = this.container.getAttribute("data-loaded-id");

		let numLoaded = 0;

		if (loadedIds !== null && loadedIds !== "") {
			if (loadedIds.indexOf(",") > -1) {
				numLoaded = loadedIds.split(",").length;
			}
			else if (loadedIds.match(/\d+/).length > 0) {
				numLoaded = 1;
			}
		}

		if (foundRows === numLoaded && this.triggerButton !== null) {
			this.triggerButton.style.display = "none";
			if (!this.isAutoLoadOnInView) {
				this.triggerButton = null;
			}
		}
		else if (this.triggerButton !== null) {
			this.triggerButton.style.display = "";
		}
	}

	/**
	 *
	 * @param {{html: string, loaded: [], total: number}} data
	 */
	onLoadSuccess(data) {

		this.container.innerHTML += data.html;
		this.container.setAttribute("data-loaded-id", data.loaded.join(","));
		this.container.setAttribute("data-total", data.total.toString());
		this.container.dispatchEvent(new Event(PostLoader.LoadSuccess))
	}

	/**
	 *
	 * @param {string} error
	 */
	onLoadError(error) {
		if (this.triggerButton !== null) {
			this.container.dispatchEvent(new Event(PostLoader.LoadError));
		}
	}

	/**
	 *
	 * @param {Event} e
	 */
	onTriggerClick(e) {
		if (!this.isLoading && !this.triggerButton.disabled) {
			this.loadArticles();
		}
	}

}
